import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/details', replace: true });
  },
});
